import { COMP_VIEW_LIST, COMP_VIEWS } from '../comp_constants';

const viewKey = userId => `compsIndexView:${userId}`;

export const getInitialView = (userId) => {
  const saved = window.localStorage.getItem(viewKey(userId));
  return COMP_VIEWS.includes(saved) ? saved : COMP_VIEW_LIST;
};

export const setInitialView = (userId, view) => window.localStorage.setItem(viewKey(userId), view);
